module.exports = __webpack_public_path__ + "static/media/precise.fb3a770d.svg";